import { Wrench } from "lucide-react";

export default function SiteFooter() {
  return (
    <footer className="border-t border-border/50 py-8">
      <div className="container flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
        <div
          className="flex items-center gap-2"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          <Wrench className="w-4 h-4 text-primary" />
          <span className="font-semibold text-foreground">スマートフォンの修理大全</span>
        </div>
        <p className="font-mono text-xs">
          データ収録: 2007–2025 / iPhone・Android 500機種以上
        </p>
        <p>© 2025 スマートフォンの修理大全</p>
      </div>
    </footer>
  );
}
